import { render, staticRenderFns } from "./NavbarButton.vue?vue&type=template&id=6589bc48&"
import script from "./NavbarButton.vue?vue&type=script&lang=js&"
export * from "./NavbarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports